import { Link } from "react-router-dom";
import { Header, Footer } from "@/components/SiteChrome";

export default function PaymentCancel() {
    return (
        <div className="min-h-screen bg-[hsl(var(--dust-50))]" data-testid="payment-cancel-page">
            <Header />
            <div className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-6">
                <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">Checkout</div>
                <h1 className="mt-4 font-display text-6xl uppercase italic text-[hsl(var(--ink))]">Payment canceled.</h1>
                <p className="mt-6 text-[hsl(var(--ink-soft))]">No charge was made. Your cart is still loaded up.</p>
                <div className="mt-10 flex justify-center gap-4">
                    <Link to="/cart" className="btn-primary">Back to cart →</Link>
                    <Link to="/shop" className="btn-ghost">Shop</Link>
                </div>
            </div>
            <Footer />
        </div>
    );
}
